// device-info.js - 디바이스 정보 유틸리티
// Extracted from app.js

/**
 * 캐시된 디바이스 이름
 * @type {string | null}
 */
let cachedDeviceName = null;

/**
 * 디바이스 이름 초기화 (앱 시작 시 호출)
 * User-Agent Client Hints API로 상세 모델명 시도, 실패 시 UA 파싱
 * @returns {Promise<void>}
 */
export async function initDeviceName() {
  // 1. Client Hints API 시도 (Chrome/Edge on Android)
  if (navigator.userAgentData?.getHighEntropyValues) {
    try {
      const hints = await navigator.userAgentData.getHighEntropyValues(['model', 'platform']);
      if (hints.model) {
        cachedDeviceName = hints.model;
        return;
      }
    } catch (e) {
      // 권한 거부 등 - fallback
    }
  }

  // 2. User Agent 파싱 fallback
  const ua = navigator.userAgent;
  if (/iPhone/.test(ua)) {
    cachedDeviceName = 'iPhone';
  } else if (/iPad/.test(ua)) {
    cachedDeviceName = 'iPad';
  } else if (/Android/.test(ua)) {
    const match = ua.match(/;\s*([^;)]+)\s*Build/);
    cachedDeviceName = match ? match[1].trim() : 'Android';
  } else {
    cachedDeviceName = 'Mobile';
  }
}

/**
 * 디바이스 이름 반환 (캐시된 값)
 * @returns {string}
 */
export function getDeviceName() {
  return cachedDeviceName || 'Mobile';
}

/**
 * 디바이스 이름 캐시 초기화 (테스트용)
 */
export function resetDeviceName() {
  cachedDeviceName = null;
}
